import styled from 'styled-components';

export const StyledCard = styled.div`
  border: 1.5px dashed #a9c7e9;
  border-radius: 4px;
  padding: 24px 16px;
  margin-bottom: 64px;

  @media ${(props) => props.theme.device.tabletL} {
    margin-bottom: 32px;
  }

  @media ${(props) => props.theme.device.mobileL} {
    padding: 24px;
  }

  /* icon+texts */
  > div:nth-child(1) {
    display: flex;
    flex-direction: column;
    row-gap: 8px;
    margin-bottom: 24px;

    @media ${(props) => props.theme.device.mobileL} {
      flex-direction: row;
      column-gap: 24px;
      margin-bottom: 32px;
    }

    /* texts */
    > div {
      display: flex;
      flex-direction: column;
      row-gap: 8px;
    }
  }

  /* button */
  > div:nth-child(2) {
    display: flex;
    justify-content: flex-end;
  }
`;
